import type { L2FilterOption } from 'ace/filterSection';
import type { Competency } from '~/modules/types/competencyFilters';
import { resolveProductCompetencyLabel } from './competencyLabelHelper';
import { buildCatalogFilterOptions, FilterCatalogOption } from './filterCatalogHelper';

/** Keep OAF field names at the source adapter; the shared builder knows nothing about competencies. */
export function adaptCompetencyCatalog(competencies: Competency[]): FilterCatalogOption[] {
    return competencies.map((competency) => ({
        id: competency.cloudId,
        name: competency.name,
        children: competency.specializations.map((specialization) => ({
            id: specialization.specializationId,
            name: specialization.name,
        })),
    }));
}

export function buildProductCompetencyOptions(
    competencies: Competency[],
    labels: I18nMessages['search']['filters']['sfExpertise'],
): L2FilterOption[] {
    return buildCatalogFilterOptions(adaptCompetencyCatalog(competencies), {
        resolveLabel: (node) => resolveProductCompetencyLabel(node.id, node.name, labels),
        // Keep source names as URL/Search values for compatibility with existing bookmarks.
        resolveValue: (node) => node.name,
    });
}
